/* eslint-disable max-lines */
import "../../css/components/Video.scss";
import React, { Component } from "react";
import classnames from "classnames";
import VisibilitySensor from "react-visibility-sensor/visibility-sensor";
import {
  Player,
  ControlBar,
  FullscreenToggle,
  CurrentTimeDisplay,
  DurationDisplay,
  TimeDivider,
  VolumeMenuButton,
  PlayToggle,
} from "video-react";
import { connect } from "react-redux";
import { carouselPlayHandler, isDraggable, pausedOnFullscreen } from "../store/actions/index";
import Svg from "./Svg";
import CaptionsSwitcher from "./CaptionsSwitcher";
import { features } from "../utils/features";
import g from "../utils/globals";
import proxy from "../proxy";
import "video-react/dist/video-react.css";
// import CloseIconVideo from "./closeIconVideo";
import { firstContentReady } from "../utils/api";
import fullscreenIcon from "../../img/video/fullscreen.svg";
import backFullscreenIcon from "../../img/video/backfullscreen.svg";
import muteIcon from "../../img/video/mute_new.svg";
import unmuteIcon from "../../img/video/unmute_new.svg";
import playIcon from "../../img/video/play.svg";
import pauseIcon from "../../img/video/pause.svg";
import dom from "../utils/dom";
import loadVideo from "../utils/loadVideo";

class Video extends Component {
  constructor(props) {
    super(props);
    this.wrapper = React.createRef();
    this.player = React.createRef();
    this.visible = false;
    this.muted = true;
    this.actionLayer = React.createRef();
    this.volumeChangeMuted = false;
    this.refMuteButton = React.createRef();
    this.fullscreenToggleButton = React.createRef();
    this.isFullscreen = false;
    this.videoSourceInfo = {};
    this.loaded = false;
    // this.renderHls = /renderHls/.test(window.location.href);
    this.main = document.querySelector("#main");
    this.changedSrc = false;
    const noLazy = this.props.config.noLazy || this.props.noLazy;
    this.state = {
      currentSource: this.props.videoSections ? this.props.sources[g.deviceOrientation] : null,
      // we don't call method currentPoster in constructor
      currentPoster: null,
      isVisible: noLazy,
      loaded: false,
      posterActive: this.props.config && this.props.config.poster,
      muted: true,
      showIcons: noLazy,
      showActionMuteIcon: false,
      controlsActive: false,
      showControls: false,
      showAutoplayIcon:
        !this.props.insideLink && !this.props.config.showLink && !this.props.renderLink && (g.channels.minip || this.props.staticVideos),
    };
    this.performanceSent = false;
    this.controlsHideTimeout = null;
  }

  componentDidMount = () => {
    if (this.state.isVisible) {
      this.loadVideoSourceInfo();
    }

    if (!features.touch) {
      const fsEvents = [
        "fullscreenchange",
        "webkitfullscreenchange",
        "mozfullscreenchange",
        "msfullscreenchange",
        "webkitbeginfullscreen",
        "webkitendfullscreen",
      ];
      fsEvents.map((event, i) => document.addEventListener(event, proxy.proxy(`${event}${i}`, this.handleFullScreenEventDesktop)));
    }
    window.addEventListener("orientationchange", proxy.proxy("#videoOrientation", this.videoOrientationChangeHandler));
    if (this.props.config.showControls) {
      this.player.current.video.video.addEventListener("mousemove", proxy.proxy("#controlsAnimationVideo", this.controlsAnimation));
      this.player.current.video.video.parentNode
        .querySelector(".video-react-control-bar")
        .addEventListener("mousemove", proxy.proxy("#controlsAnimationControls", this.controlsAnimation));
    }
  };

  componentWillUnmount = () => {
    this.state.videoSourceInfo?.hls?.destroy();
    this.player.current?.video?.video?.pause();
  };

  componentDidUpdate = async () => {
    if (this.state.isVisible && !this.state.loaded) {
      await this.loadVideoSourceInfo();
    }
    if (this.changedSrc) {
      this.changedSrc = false;
      this.player.current.video.load();
    }
  };

  checkVisibleLoad = isVisible => {
    if (!this.state.isVisible && isVisible) {
      this.setState(
        {
          isVisible: true,
          showIcons: true,
        },
        () => {
          this.hideIcons();
        }
      );
    }
  };

  loadVideoSourceInfo = async () => {
    const { url, timestamp, notPristine, src } = this.props.config;
    this.setState(prevState => ({ ...prevState, loaded: true }));
    const node = this.player.current.video.video;
    const sourceInfo = await loadVideo(
      {
        src: this.props.src || src,
        videoAttributes: { url, timestamp, notPristine },
        context: {
          features,
          videoBaseUrl: g.videoContent,
        },
      },
      node
    );
    this.setState(prevState => ({ ...prevState, videoSourceInfo: sourceInfo }));
  };

  checkVisiblePlay = isVisible => {
    if (isVisible) {
      if (!this.props.carouselStore.pausedOnFullscreen && !this.props.staticVideos && !this.state.showAutoplayIcon) {
        this.player.current.actions.play();
      }
    } else if (!this.isFullscreen) {
      if (!this.props.playingVideos) {
        this.player.current.video.video.pause();
      }
    }
  };

  handleMute = () => {
    if (this.props.carousel && this.props.carouselStore.isTap) {
      return this.player.current.actions.mute(!this.player.current.muted);
    }
    this.player.current.actions.mute(!this.player.current.muted);
    this.muted = !this.muted;
    // document.querySelectorAll("video").forEach(vid => (vid.muted = this.muted));
    this.setState(
      {
        showActionMuteIcon: true,
      },
      this.hideIcons
    );
  };

  handleVolumChange = isMuted => {
    this.volumeChangeMuted = isMuted;
    this.setState(prevState => ({
      ...prevState,
      muted: isMuted,
    }));
    if (this.refMuteButton.current) {
      if (isMuted && !this.refMuteButton.current.classList.contains("muted")) {
        this.refMuteButton.current.classList.add("muted");
      } else if (!isMuted && this.refMuteButton.current.classList.contains("muted")) {
        this.refMuteButton.current.classList.remove("muted");
      }
    }
  };

  togglePlayHandler = () => {
    if (this.player.current.video.video.paused) {
      this.player.current.actions.play();
    } else {
      this.player.current.actions.pause();
    }
  };

  handleFullscreenOpen = () => {
    const fullscreenLogic = () => {
      this.isFullscreen = true;
      this.player.current.actions.play();
      this.player.current.actions.mute(false);

      if (this.isSafariIOS()) {
        dom.addBodyClass("componentFullscreened");
      }
      this.player.current.video.toggleFullscreen();
    };
    const nativeInterface = window.nativeFullscreen || window.nativeFunctions;
    if (nativeInterface) {
      const videoSrc = this.actionLayer.current.getAttribute("data-src");
      if (nativeInterface.onClick) {
        nativeInterface.onClick(videoSrc);
      } else if (nativeInterface.fullscreen) {
        nativeInterface.fullscreen(videoSrc);
      }
      this.player.current.actions.mute(true);
      this.muted = true;
    } else {
      fullscreenLogic();
    }
  };
  handleBackFullscreen = () => {
    this.player.current.video.toggleFullscreen();
    this.exitFullscreenHandler();
    this.isFullscreen = false;
  };
  actionLayerHandler = () => {
    if (this.props.carousel && !this.props.carouselStore.isTap) return;
    switch (true) {
      case this.props.config.fullscreen && (this.props.config.muteButton || this.props.showMuteBtn):
        this.showIcons();
        if (this.player.current.video.video.paused) {
          this.player.current.actions.play();
        }
        break;
      case this.props.config.fullscreen:
        this.handleFullscreenOpen();
        break;
      default:
        if (this.props.config.muteButton || this.props.showMuteBtn) {
          this.handleMute();
        }
        if (this.player.current.video.video.paused) {
          this.player.current.actions.play();
        }
        break;
    }
  };
  exitFullscreenHandler = () => {
    if (this.isSafariIOS()) {
      dom.removeBodyClass("componentFullscreened");
    }
    if (this.isFullscreen) {
      this.wrapper?.current?.scrollIntoView({
        block: "center",
        inline: "center",
      });
    }
    this.isFullscreen = false;
    if (this.player.current) {
      if (this.volumeChangeMuted) {
        this.player.current.actions.mute(true);
        this.muted = this.volumeChangeMuted;
      } else {
        this.player.current.actions.mute(this.muted);
      }
    }
    if (this.props.carousel) {
      if (!this.props.carouselStore.scrolled) {
        this.props.carouselPlayHandler(true);
      }
      this.props.isDraggable(true);
    }
  };

  handleFullScreenEventDesktop = () => {
    const isFullScreen =
      Boolean(document.fullscreenElement) ||
      Boolean(document.webkitFullscreenElement) ||
      Boolean(document.mozFullScreenElement) ||
      Boolean(document.msFullscreenElement);
    if (isFullScreen) {
      if (this.props.carousel) {
        this.props.carouselPlayHandler(false);
        this.props.isDraggable(false);
      }
    } else {
      this.exitFullscreenHandler();
    }
  };
  handlePauseOnFullscreen = () => {
    if (this.isFullscreen) {
      this.props.pausedOnFullscreen(true);
    }
  };
  handlePlay = () => {
    if (this.state.showAutoplayIcon) {
      this.setState({ showAutoplayIcon: false });
    }
    if (!this.performanceSent) {
      this.performanceSent = true;
      firstContentReady(this.props);
    }
    if (this.isFullscreen) {
      this.props.pausedOnFullscreen(false);
    }
  };
  handleProgress = () => {
    let isHidden = false;
    return () => {
      if (!isHidden) {
        const poster = this.wrapper.current.querySelector(".video-react-poster");
        if (poster) {
          poster.style.display = "none";
        }
        isHidden = true;
      }
    };
  };

  videoOrientationChangeHandler = () => {
    if (this.props.videoSections) {
      if (window.innerWidth < window.innerHeight) {
        this.setState(prevState => ({
          ...prevState,
          currentSource: this.props.sources.landscape,
        }));
      } else {
        this.setState(prevState => ({
          ...prevState,
          currentSource: this.props.sources.portrait,
        }));
      }
    }
  };
  showIcons = () => {
    if (this.iconsTimeout) {
      clearTimeout(this.iconsTimeout);
    }
    if (!this.state.showIcons) {
      this.setState(
        {
          showIcons: true,
        },
        () => this.hideIcons()
      );
    } else {
      this.hideIcons();
    }
  };
  hideIcons = () => {
    this.iconsTimeout = setTimeout(() => {
      this.setState({
        showIcons: false,
        showActionMuteIcon: false,
      });
    }, 3000);
  };

  hideControls = () => {
    clearTimeout(this.controlsHideTimeout);
    this.controlsHideTimeout = setTimeout(() => {
      this.setState(prevState => ({
        ...prevState,
        showControls: false,
      }));
    }, 2000);
  };

  controlsAnimation = () => {
    if (!this.state.showControls) {
      this.setState(prevState => ({
        ...prevState,
        showControls: true,
      }));
    }
    this.hideControls();
  };

  renderEvent = e => {
    if (this.player.current.video.video.readyState === 4) {
      g.renderingCheck.add(e.nativeEvent.srcElement.currentSrc);
    }
  };

  isSafariIOS = () => {
    var isSafari = !!navigator?.userAgent?.match(/Version\/[\d.]+.*Safari/);
    var iOS = /iPad|iPhone|iPod/.test(navigator?.userAgent) && !window?.MSStream;
    return isSafari && iOS;
  };

  render() {
    if (this.props.carousel && this.props.config.fullscreen && features.touch) {
      this.props.config.fullscreen = false;
    }
    const renderActionLayerMuteBtn = () => (
      <div
        className={`video-layer-mute-icon ${this.state.showActionMuteIcon ? "mute-icon-visible" : ""} ${
          this.props.config.muteButtonWhite ? "mute-white" : ""
        }`}
      >
        <div className="video-layer-mute-icon-wrapper">
          <Svg svg={this.state.muted ? muteIcon : unmuteIcon} />
        </div>
      </div>
    );

    const actionLayer = withLink => {
      let desktopStr = this.state.videoSourceInfo?.src || `${this.props.config.url}_0.m3u8`;
      desktopStr = desktopStr.replace(/_0_0.m3u8/, "_0.m3u8");
      return (
        <div
          ref={this.actionLayer}
          className={classnames("actionLayer", {
            nativeVideoOverlay: this.props.config.fullscreen,
            controls: this.props.config.showControls,
          })}
          data-src={desktopStr}
          onClickCapture={!withLink ? this.actionLayerHandler : null}
          style={this.props.config.muteButton || this.props.showMuteBtn || this.props.config.fullscreen ? { cursor: "pointer" } : null}
        >
          {(this.props.config.muteButton || this.props.showMuteBtn) && renderActionLayerMuteBtn()}
        </div>
      );
    };
    const renderActionLayer = () => {
      if (this.props.config.showLink && this.props.renderLink) {
        return this.props.renderLink(actionLayer(true), true);
      }
      return actionLayer();
    };

    const RenderFullscreenBtn = props => (
      <div
        className={classnames("video-action-btn fullscreen-btn", {
          "control-bar-icon": props.controlBar,
        })}
        onClick={this.handleFullscreenOpen}
      >
        <Svg svg={fullscreenIcon} />
      </div>
    );
    const renderMuteBtn = () => (
      <div className="video-action-btn mute-btn" onClick={this.handleMute}>
        <Svg svg={this.state.muted ? muteIcon : unmuteIcon} />
      </div>
    );
    const renderVideoIcons = () => (
      <div
        className={`video-control-icons ${this.props.config.muteButtonWhite ? "icons-white" : ""} ${
          this.state.showIcons ? "icons-visible" : ""
        }
        `}
        onClick={this.showIcons}
      >
        {this.props.config.muteButton && renderMuteBtn()}
        {this.props.config.fullscreen && <RenderFullscreenBtn />}
      </div>
    );
    // const resolvePoster = () => {
    //   if (typeof this.props.config.poster === "object") {
    //     return this.props.config.poster[g.deviceOrientation];
    //   } else if (typeof this.props.config.poster === "string") {
    //     return this.props.config.poster;
    //   }
    // };
    const PlayIcon = () => (
      <div className="control-bar-icon play" onClick={this.togglePlayHandler}>
        <Svg svg={this.player.current && this.player.current.video.video.paused ? playIcon : pauseIcon} />
      </div>
    );

    const MuteIcon = () => (
      <div className="control-bar-icon mute" onClick={this.handleMute}>
        <Svg svg={this.state.muted ? muteIcon : unmuteIcon} />
      </div>
    );

    const BackFullscreenIcon = () => (
      <div className="control-bar-icon back-fullscreen" onClick={this.handleBackFullscreen}>
        <Svg svg={backFullscreenIcon} />
      </div>
    );
    const renderVideo = () => {
      const { src, type } = this.state?.videoSourceInfo || {};
      return (
        <Player
          className={classnames({
            "video-faded": this.state.showAutoplayIcon,
          })}
          playsInline
          fluid={false}
          width="100%"
          height="auto"
          muted
          autoPlay={!g.channels.minip && !this.props.staticVideos}
          loop
          ref={this.player}
          onVolumeChange={() => this.handleVolumChange(this.player.current.muted)}
          onPause={this.handlePauseOnFullscreen}
          onPlay={this.handlePlay}
          onProgress={this.handleProgress()}
          onSuspend={g.eagerMode ? e => this.renderEvent(e) : null}
          // poster={resolvePoster()}
          controls={true}
        >
          <source src={src} type={type} />
          <ControlBar>
            <CurrentTimeDisplay disabled />
            <DurationDisplay disabled />
            <TimeDivider disabled />
            <VolumeMenuButton disabled />
            <PlayToggle disabled />
            <FullscreenToggle disabled />
            {(this.props.config.muteButton || this.props.showMuteBtn) && <MuteIcon />}
            <PlayIcon />
            {this.props.config.showControls && !this.isFullscreen ? <RenderFullscreenBtn controlBar /> : <BackFullscreenIcon />}
          </ControlBar>
          <CaptionsSwitcher controlsAnimation={this.controlsAnimation} fullscreened={this.isFullscreen} />
        </Player>
      );
    };
    const renderComponent = () => {
      return (
        <div
          ref={this.wrapper}
          id={this.props.config?.id || this.props.attrs?.id}
          className={classnames("videoWrapper", {
            [this.props.config.className]: this.props.config.className,
            videoWrapper_controls: this.props.config.showControls,
            hideControls: false, // this.props.config.showControls && !this.state.showControls,
            shown: true || (this.props.config.showControls && this.state.showControls),
            "video-styled": this.props.styles,
          })}
          style={this.props.styles || {}}
        >
          {!this.props.scenes ? renderActionLayer() : null}
          {!this.props.config.showControls && renderVideoIcons()}
          {/* {this.state.posterActive && renderPoster()} */}
          {renderVideo()}
        </div>
      );
    };
    const renderVisibilityWrapper = () => {
      const noLazy = this.props.config.noLazy || this.props.noLazy;
      const loadOffset = g.channels.desktop ? -500 : -120;
      return (
        <VisibilitySensor
          onChange={isVisible => this.checkVisiblePlay(isVisible)}
          partialVisibility
          delayedCall={true}
          offset={{ top: -10, left: -10, right: -10, bottom: -10 }}
        >
          {!this.props.scenes && !noLazy ? (
            <VisibilitySensor
              active={!noLazy || !this.state.loaded}
              delayedCall={true}
              onChange={isVisible => this.checkVisibleLoad(isVisible)}
              offset={{ top: loadOffset, left: loadOffset, right: loadOffset, bottom: loadOffset }}
            >
              {renderComponent()}
            </VisibilitySensor>
          ) : (
            renderComponent()
          )}
        </VisibilitySensor>
      );
    };
    return renderVisibilityWrapper();
  }
}

const mapStateToProps = state => ({
  carouselStore: state.carouselStore,
});

const mapDispatchToProps = dispatch => ({
  carouselPlayHandler: running => dispatch(carouselPlayHandler(running)),
  isDraggable: draggable => dispatch(isDraggable(draggable)),
  pausedOnFullscreen: paused => dispatch(pausedOnFullscreen(paused)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Video);
